export const easeInQuart = 'cubic-bezier(0.5, 0, 0.75, 0)'; // https://easings.net/#easeInQuart
export const easeOutQuart = 'cubic-bezier(0.25, 1, 0.5, 1)'; // https://easings.net/#easeOutQuart
